$(document).ready(function() {
  document.querySelectorAll(".countdown-shadow").forEach(el => {
    countDown(el, el.dataset.createdAt);
  })
})

const countDown = (elm, time) => {
  var diff_10_min   = time;
  var countDownDate = new Date(new Date().getTime() + diff_10_min*1000);

  // Update the count down every 1 second
  var x = setInterval(function() {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    // var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result in the element with class="count-down"
    Array.prototype.forEach.call(elm.querySelectorAll('.countdown-shadow-elm'), function(elem) {
        var hours_s = (hours).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
        var minutes_s = (minutes).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})
        var seconds_s = (seconds).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})

        elem.innerHTML = hours_s + ":" + minutes_s + ":" + seconds_s;
    })

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(x);
      Array.prototype.forEach.call(elm.querySelectorAll('.countdown-shadow-elm'), function(elem) {
        elem.innerHTML = "Expired"

        var bg_content_scheme = elem.closest('.countdown-shadow-wrapper')
        if (bg_content_scheme != null) {
          var button_pay_now = bg_content_scheme.querySelectorAll('.button-paynow')
          button_pay_now.forEach(function(btnPaynow) {
            btnPaynow.setAttribute('disabled', 'disabled')
            btnPaynow.classList.add('disabled')
          })
        }
      })

      setTimeout(function() {
        // window.location.reload();
      }, 500)
    }
  }, 1000);
}
